var freeDeliveryThresholdContainer = document.getElementById('freeDeliveryThresholdContainer');
var freeDeliveryActivatedContainer = document.getElementById('freeDeliveryActivatedContainer');
var freeDeliveryThresholdPrice = document.getElementById('freeDeliveryThreshold');

function updateDeliveryThreshold(total) {

    if (total < freeDeliveryThreshold) {
        freeDeliveryThresholdContainer.classList.remove('sf--hidden');
        freeDeliveryActivatedContainer.classList.add('sf--hidden');
    } else {
        freeDeliveryThresholdContainer.classList.add('sf--hidden');
        freeDeliveryActivatedContainer.classList.remove('sf--hidden');
    }
    var threshold = freeDeliveryThreshold - total
    remainder = Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active
    }).format(threshold);
    freeDeliveryThresholdPrice.innerHTML = remainder
}


document.addEventListener('cart:updated', function(evt) {
    var total = evt.detail.cart.total_price/100
    updateDeliveryThreshold(total)
    var klarnaPlacement = document.querySelector('klarna-placement')
    if (klarnaPlacement) {
        klarnaPlacement.setAttribute('data-purchase-amount', evt.detail.cart.total_price)
        window.Klarna.OnsiteMessaging.refresh();
    }
});

document.addEventListener('cart:open', function(evt) {
    console.log('Cart opened')
});

document.addEventListener('ajaxProduct:added', function(evt) {
    fetch('/cart.js')
        .then(function(response){
            return response.json()
        })
        .then(function(cart){
            updateDeliveryThreshold(cart.total_price/100)
        }).catch(function(err) {
            console.error(err)
      });
});

// load namespace
let SV;
SV = window.SV || {};

SV.HoverIntent = (function () {
    // constructor
    return function (elements, userConfig) {
        // private members

        const defaultOptions = {
            exitDelay: 400,
            interval: 100,
            sensitivity: 7,
        };
        let config = {};

        let currX, currY, prevX, prevY;
        let allElems, pollTimer, exitTimer;

        // private methods

        // override default options with user config
        const extend = function (defaults, userArgs) {
            for (let i in userArgs) {
                defaults[i] = userArgs[i];
            }

            return defaults;
        };

        // update mouse position
        const mouseTrack = function (ev) {
            currX = ev.pageX;
            currY = ev.pageY;
        };

        // check if mouse movement has slowed enough to trigger active state
        const mouseCompare = function (targetElem) {
            const distX = prevX - currX,
                distY = prevY - currY;
            const distance = Math.sqrt(distX * distX + distY * distY);

            if (distance < config.sensitivity) {
                // if we re-entered an element, cancel delayed exit and clear any active elements immediately
                clearTimeout(exitTimer);
                for (let elem of allElems) {
                    if (elem.isActive) {
                        config.onExit(elem);
                        elem.isActive = false;
                    }
                }

                // trigger hover
                config.onEnter(targetElem);
                targetElem.isActive = true;
            } else {
                // update previous coordinates and try again later
                prevX = currX;
                prevY = currY;
                pollTimer = setTimeout(function () {
                    mouseCompare(targetElem);
                }, config.interval);
            }
        };

        const init = function (elements, userConfig) {
            if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
                throw "onEnter and onExit callbacks must be provided";
            }
            config = extend(defaultOptions, userConfig);
            allElems = elements;

            for (let elem of allElems) {
                // holds current element state
                elem.isActive = false;
                // keeps track of mouse position
                elem.addEventListener("mousemove", mouseTrack);

                elem.addEventListener("mouseenter", function (ev) {
                    // set initial entry position
                    prevX = ev.pageX;
                    prevY = ev.pageY;
                    // if this element is already active, cancel exit
                    if (elem.isActive) {
                        clearTimeout(exitTimer);
                        return;
                    }

                    // while mouse is over this element, check distance every 100ms
                    pollTimer = setTimeout(function () {
                        mouseCompare(elem);
                    }, config.interval);
                });
                elem.addEventListener("mouseleave", function (ev) {
                    clearTimeout(pollTimer);
                    if (!elem.isActive) return;

                    exitTimer = setTimeout(function () {
                        config.onExit(elem);
                        elem.isActive = false;
                    }, config.exitDelay);
                });
            }
        };

        init(elements, userConfig);
    };
})();

let $megaMenuToggle = $("[data-mega-menu-toggle]");
let $megaMenuToggleLink = $megaMenuToggle.find("> a");
var instance = new SV.HoverIntent($megaMenuToggle, {
    onEnter: function (targetItem) {
        // find the item, which is a <li>
        let $item = $(targetItem);
        // Add an active class for styling, etc
        if ($item.hasClass("is--mega-menu")) $item.addClass("is--open");
        // Get the nearest mega menu
        let $megaMenuContainer = $item.find("[data-mega-menu]");
        // Show the mega menu
        $megaMenuContainer.addClass("is--open");
        // Find all links and make it a different text colour
        $megaMenuToggleLink.addClass("opacity-50");
        // Find the link and make it a different text colour
        let $link = $item.find("> a");
        // Focus the current link
        $link.removeClass("opacity-50");
    },
    onExit: function (targetItem) {
        // Remove the open class
        $("[data-mega-menu-toggle]").removeClass("is--open");
        // Reset all links
        $megaMenuToggleLink.removeClass("opacity-50");
        // Hide the panels
        $("[data-mega-menu]").removeClass("is--open");
    },
    sensitivity: 7,
});


/**
*
* Close / Open the mobile nav
*
*/
function toggleMobileNav() {
    $('[data-mobile-menu]').toggleClass('is--active')
    $('[data-hamburger] .close-button').toggleClass('hidden')
    $('[data-mobile-menu-alt]').toggleClass('is--active')
    $('[data-mobile-menu-child]').scrollTop(0);
    $('body')
        .toggleClass('overflow-hidden')
        .toggleClass('mobile-nav-open')
}

/**
*
* Toggle the hamburger
*
*/
let $hamburger = $('[data-hamburger]')
$hamburger.on('click', function(e){
    $(this).toggleClass('is-active')
    e.preventDefault()
    toggleMobileNav()
})

/**
*
* Toggle the child menus on mobile
*
*/
let $childToggle = $('[data-mobile-menu-child-toggle]')
$childToggle.on('click', function(e){
    e.preventDefault()
    let id = $(this).data('mobile-menu-child-toggle')
    $('[data-mobile-menu-child]').scrollTop(0);
    $('[data-mobile-menu-child]').removeClass('is--active')
    $('[data-mobile-menu-child="'+id+'"]').addClass('is--active')
})
/**
*
* Toggle the child menus on mobile
*
*/
let $childToggleBack = $('[data-mobile-menu-child-back]')
$childToggleBack.on('click', function(e){
    e.preventDefault()
    $('[data-mobile-menu-child]').removeClass('is--active')
})

$(function() {
    // Select all elements with the class '.promo-grid-carousel'
    $('.promo-grid-carousel').each(function() {
        // Initialize Flickity for each selected element
        var promoGrid = new Flickity(this, {
            pageDots: true,
            cellSelector: '.carousel-cell'
        });

        // Listen for the 'lazyloaded' event to resize the current Flickity instance
        document.addEventListener('lazyloaded', function(e) {
            if (e.target.closest('.promo-grid-carousel') === this) {
                promoGrid.resize();
            }
        }.bind(this));
    });
});

